import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { getPlantData, getClimateData } from "../../store/design/actions"
import { getAreas, updateArea, deleteArea, addArea } from "../../store/goals/actions"
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import {
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"

import { Image } from '@aws-amplify/ui-react';
import Storage from '@aws-amplify/storage'


const Goals = props => {
  const { plantData, userareas, onAddArea, onDeleteArea, onUpdateArea } = props
  const [singlebtn, setSinglebtn] = useState(false)
  const [expandMenu, setExpandMenu] = useState(false)
  const [plantModal, setPlantModal] = useState(false)
  const [addTaskModal, setAddTaskModal] = useState(false)
  const [editTaskModal, setEditTaskModal] = useState(false)
  const [isPlantEdit, setPlantEdit] = useState(false)
  const [currGoal, setCurrGoal] = useState({})
  const [currArea, setCurrArea] = useState({})
  const [currTask, setCurrTask] = useState({})
  const [species, setSpecies] = useState()
  const [variety, setVariety] = useState()
  const [name, setName] = useState()
  const [taskType, setTaskType] = useState()
  const [taskArea, setTaskArea] = useState()
  const [taskPlants, setTaskPlants] = useState([])
  const [taskObjective, setTaskObjective] = useState()
  const [taskStatus, setTaskStatus] = useState()
  const [taskEndDate, setTaskEndDate] = useState()
  const [goals, setGoals] = useState([])
  const [daysToHarvest, setDaysToHarvest] = useState()
  const [numPlants, setNumPlants] = useState()
  const [text, setText] = useState("")
  const [plantIndex, setPlantIndex] = useState()
  const [goalExpand, setGoalExpand] = useState(Array(20).fill(false))

  const plantStatusOptions = [
	  {"value": "Seed Starting",
           "text": "Seed Starting"},
          {"value": "Transplanting",
           "text": "Transplanting"},
          {"value": "Growing",
           "text": "Growing"},
          {"value": "Harvest",
           "text": "Harvest"}];

  const taskTypeOptions = [
	  {"value": "Maintenance", 
	   "text": "Maintenance"},
          {"value": "Cultivation",
           "text": "Cultivation"},
          {"value": "Research",
           "text": "Research"},
          {"value": "Harvest",
           "text": "Harvest"},
          {"value": "Seed Starting",
           "text": "Seed Starting"},
          {"value": "Transplanting",
           "text": "Transplanting"},
          {"value": "Seed Saving",
           "text": "Seed Saving"}
  ];

   const taskStatusOptions = [
          {"value": "Not Started",
           "text": "Not Started"},
          {"value": "In Progress",
           "text": "In Progress"},
          {"value": "Completed",
           "text": "Completed"},
          {"value": "Paused",
           "text": "Paused"},
          {"value": "Failed",
           "text": "Failed"}
  ];

  useEffect(() => {
	    const { onGetPlantData, onGetAreas } = props
	    onGetPlantData()
	    onGetAreas()
	    var testgoals = [
              {
		 name: "Spring Goals",
		 tasks:
		      [ 
			{ id: 234234,
			  type: "harvest",
			  area: "Long Bed 17",
			  plants: "Melon",
			  objective: "weight",
			  status: "Not Started",
			  endDate: "03/04/2023"
			},
			{ id: 23234,
                          type: "maintenance",
                          area: "Long Bed 17",
			  plants: "",
                          objective: "Tidy Up",
                          status: "In Progress",
                          endDate: "03/04/2023"
                        },
		        { id: 23234,
                          type: "seedstarting",
                          area: "Long Bed 17",
		          plants: "Melon",
                          objective: "Start Spring seeds",
                          status: "Completed",
                          endDate: "03/04/2023"
                        }

	          ]
	      }]
	   setGoals(testgoals)
  }, [])

  function addTask (goal) {
      setCurrGoal(goal)
      const newTask = {
            type: "",
            area: "",
            plants: [],
            status: "",
            objective: "",
            endDate: "",
     }
     let tasks = goal.tasks;
     tasks.push(newTask);
     const newGoal = { ...currGoal, [tasks]: tasks };
     setAddTaskModal(!addTaskModal)
  }

  function editTask (goal, taskindex) {
      if (goal) {
	 setCurrGoal(goal)
         setCurrTask(goal.tasks[taskindex])
      }
      setEditTaskModal(!editTaskModal)
  }

  function deleteTask (goal, taskindex) {
  }

  function getTaskArea () {
      var listareas = [];
      for (var i=0; i<userareas.length; i++) {
          listareas.push({"value":userareas[i].name, "text":userareas[i].name})
      }
      return listareas;
  }

  function taskChange (target) {
      if (target.props.name=="taskType") {
          currTask["type"] = target.newValue;
          setCurrTask(currTask);
      } else if (target.props.name=="taskArea") { 
	  currTask["area"] = target.newValue;
	  setCurrTask(currTask);
      } else if (target.props.name=="taskPlants") {
	  currTask["plants"] = target.newValue;
	  setCurrTask(currTask);
      } else if (target.props.name=="taskObjective") {
	  currTask["objective"] = target.newValue;
	  setCurrTask(currTask);
      } else if (target.props.name=="taskStatus") {
	  currTask["status"] = target.newValue;
	  setCurrTask(currTask);
      } else if (target.props.name=="taskEndDate") {
	  currTask["endDate"] = target.newValue;
	  setCurrTask(currTask);
      }
      
      //onUpdateArea(areas[areaIndex])
  }

  function createNewTask() {
    setAddTaskModal(!addTaskModal)
 }

 function changeGoalName(goalIndex) {
 }

 function cancelNewTask() {
    var currTaskSize = currGoal.tasks.length
    currGoal.tasks.splice(currTaskSize-1,1)
    setAddTaskModal(!addTaskModal)
 }

 function addGoal () {
 }

  const saveProject = () => {
          // placehold for saving a project
}

const handleSelect = e => {
    console.log(e);
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
	  
<Row>
	  <Col md={2}>
               <Card style={{borderWidth: "0px", padding: "0px", margin: "0px"}}>
                    <CardTitle><p onClick={e => {
                                                           addGoal()
                        }}
 style={{padding: "0px", margin: "0px", textAlign: "left", cursor: "pointer"}}><i className="bx bx-add-to-queue" style={{fontSize: "20px"}}/> Add Goal</p></CardTitle>
               </Card>
        </Col>
</Row>
	  {goals.map ((goal, index1) => (
        <Card className="mb-1">
                      <CardHeader style={{width: "100%", backgroundColor: "#BEC8B6"}} >
	   <Row>
                           <Col md={2}
                            className="text-dark"
                          >

                            <span onClick={() => {
                                goalExpand[index1] = !goalExpand[index1];
                                var fooExpand = goalExpand.map((x) => x);
                                setGoalExpand(fooExpand)
                            }}
                            style={{ cursor: "pointer" }}>
        {goal.name} &nbsp;&nbsp;</span>

                       <Button style={{padding: "5px",  backgroundColor: "#BEC8B6" }} className="btn btn-outline-secondary" onClick={() => changeGoalName(index1)}>
                           <i style={{color:"#545a6d"}} className="bx bx-edit-alt"></i>
                      </Button>

                        </Col>
                        <Col md={9} onClick={() => {
                                goalExpand[index1] = !goalExpand[index1];
                                var fooExpand = goalExpand.map((x) => x);
                                setGoalExpand(fooExpand)

                            }}
                            style={{ cursor: "pointer" }}
                            >&nbsp;</Col>
                        </Row>

                     </CardHeader>
	 <Collapse style={{margin: "20px 0"}} isOpen={goalExpand[index1]}>
                     <Row style={{padding: "5px",  backgroundColor: "#CFC8B6" }}>
		        <Col md={2}>Type</Col>
		        <Col md={1}>Area</Col>
		        <Col md={2}>Plant</Col>
		        <Col md={2}>Objective</Col>
		        <Col md={1}>Status</Col>
		        <Col md={1}>End Date</Col>
		         <Col md={1}></Col>
		    </Row>
		    <Row>
		        <Col md={2}><p onClick={e => {
                                                           addTask(goal)
                        }}
 style={{padding: "0px", margin: "0px", textAlign: "left", cursor: "pointer"}}><i className="bx bx-add-to-queue" style={{fontSize: "20px"}}/> Add Task</p></Col>              
		     </Row>
		    {goal.tasks.map((task, tindex) => (
                      <Row>
			  <Col md={2}>{task.type}</Col>
			   <Col md={1}>{task.area}</Col>
                        <Col md={2}>{task.plants}</Col>
                        <Col md={2}>{task.objective}</Col>
                        <Col md={1}>
			    {
                               {
                                   'In Progress':  <Badge color="warning" className="mr-1">In Progress</Badge>,
		                   'Not Started':  <Badge color="info" className="mr-1">Not Started</Badge>,
			           'Paused':  <Badge color="dark" className="mr-1">Paused</Badge>,
                                   'Completed':  <Badge color="success" className="mr-1">Completed</Badge>,
                                   'Failed':  <Badge color="error" className="mr-1">Failed</Badge>

                               }[task.status]
                            }
                        </Col>
                        <Col md={1}>{task.endDate}</Col>
			<Col md={1}> <Button style={{padding: "5px", backgroundColor:"#FFFFFF"}} className="btn btn-outline-secondary" onClick={() => editTask(goal,tindex)}>
                           <i style={{color:"#545a6d"}} className="bx bx-edit-alt"></i>
                      </Button>

                      <Button style={{padding: "5px", backgroundColor:"#FFFFFF"}}  onClick={(e) => {deleteTask(goal,tindex)}} className="btn btn-outline-secondary">
                           <i style={{color:"#545a6d"}} className="bx bx-trash"></i>
                      </Button>
			 </Col>

                       </Row>

                       ))}
          </Collapse>
     </Card>
 ))}


<Modal isOpen={addTaskModal} toggle={() => {

 }}
  >
<ModalHeader tag="h4">
        Add Task
    </ModalHeader>
    <ModalBody>
       <Form>
           <Row>
              <Col><b>Type</b></Col>
              <Col>
                   <Input type="select"  onChange={event => {
                               setTaskType(event.target.value);
                          }}
                           >
                        <option value="Maintenance">Maintenance</option>
	                <option value="Cultivation">Cultivation</option>
	                <option value="Research">Research</option>
	                <option value="Harvest">Harvest</option>
	                <option value="Seed Starting">Seed Starting</option>
	                <option value="Transplanting">Transplanting</option>
	                <option value="Seed Saving">Seed Saving</option>
                   </Input>
              </Col>
         </Row>
         <Row>
              <Col md={6}><b>Area</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                          }}>
                     {userareas.map ( (area)=> (
			   <option value={area.name}>{area.name}</option>
			))}
                    </Input>
              </Col>
         </Row>
         <Row>
              <Col md={6}><b>Plants</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setTaskPlants(event.target.value);
                          }}>
                     {currArea.plants.map ( (plant)=> (
                           <option value={plant.name}>{plant.name}</option>
                        ))}
                    </Input>
	            <Button>Add Plant to Task</Button>
              </Col>
         </Row>
         <Row>
              <Col md={6}><b>Objective</b></Col>
              <Col md={6}>
                    <Input type="text" onChange={event => {
                               setTaskObjective(event.target.value);
                          }}/>
              </Col>
         </Row>
         <Row>
              <Col md={6}><b>Status</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setTaskStatus(event.target.value);
                          }}>
	                    <option value="Not Started">Not Started</option>  
	                    <option value="In Progress">In Progress</option>
                            <option value="Completed">Completed</option>
                            <option value="Paused">Paused</option>
                            <option value="Failed">Failed</option>
                    </Input>
              </Col>
         </Row>
         <Row>
              <Col md={6}><b>Start Date</b></Col>
              <Col md={6}>
                    <DatePicker
                                className="form-control"
                                selected={taskEndDate}
                                onChange={value => {
                               setTaskEndDate(value);
                          }}

                          />

              </Col>
         </Row>



         <Row style={{ paddingTop: "10px"}}>
              <Col md="4"/>
              <Col md="2">
                   <Button
                       onClick={e => { createNewTask()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Create
                   </Button>
              </Col>
              <Col md="2">
                  <Button
                       onClick={e => { cancelNewTask()  }}
                       color="primary"
                       className="btn-sm"
                    >
                     Cancel
                   </Button>
              </Col>
            </Row>


        </Form>
    </ModalBody>
</Modal>


<Modal isOpen={editTaskModal} toggle={() => {
            editTask()
 }}
>
    <ModalHeader tag="h4">
        Edit Task 
    </ModalHeader>
    <ModalBody>
       <Form>
           <Row>
                         <Col md={6}><b>Type</b></Col>
                         <Col md={6}>
                               <Editable
                                      name="taskType"
                                      value={currTask.type}
                                      options={taskTypeOptions}
                                      dataType="select"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
                         </Col>

                      </Row>
             <Row>
                         <Col md={6}><b>Area</b></Col>
                         <Col md={6}>
                               <Editable
                                      name="taskArea"
                                      value={currTask.area}
                                      options={userareas.map(area => ({ value: area.name, text: area.name }))}
                                      dataType="select"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
                         </Col>

                      </Row>
	 <Row>
              <Col md={6}><b>Plants</b></Col>
              <Col md={6}>
	             <Editable
                                      name="taskPlants"
                                      value={currTask.plants}
                                      options={plantData}
                                      dataType="select"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
              </Col>
         </Row>
  <Row>
              <Col md={6}><b>Objective</b></Col>
              <Col md={6}>
	               <Editable
                                      name="taskObjective"
                                      value={currTask.objective}
                                      dataType="text"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />

              </Col>
         </Row>
<Row>
              <Col md={6}><b>Status</b></Col>
              <Col md={6}>
                     <Editable
                                      name="taskStatus"
                                      value={currTask.status}
                                      options={taskStatusOptions}
                                      dataType="select"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
              </Col>
         </Row>
  <Row>
              <Col md={6}><b>Start Date</b></Col>
              <Col md={6}>
	            <Editable
                                      name="taskStartDate"
                                      value={currTask.endDate}
                                      dataType="date"
                                      mode="inline"
                                      handleSubmit={taskChange}
                      />

              </Col>
         </Row>

        </Form>
    </ModalBody>
</Modal>


        </Container>
      </div>
    </React.Fragment>
  )
}

Goals.propTypes = {
  resources: PropTypes.array,
}

const mapStateToProps = (state, ownProps) => { 
  const sortedPlants = state.designer.plants.sort((a, b) => (a.name > b.name) ? 1 : -1);
  var plantOptions = sortedPlants.map((x)=>({"value":x.name, "text":x.name}))	
  return {
  plantData: plantOptions,
  userareas: state.goals.areas,
  }
}

const mapDispatchToProps = dispatch => ({
  onGetPlantData: () => dispatch(getPlantData()),
  onUpdateArea: area => dispatch(updateArea(area)),
  onAddArea: area => dispatch(addArea(area)),
  onDeleteArea: id => dispatch(deleteArea(id)),
  onGetAreas: () => dispatch(getAreas()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Goals))
